import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import api from "services/baseService";

type Impression = {
  orderId: number;
  type: "Physical" | "Scanner" | "Digital";
  date: string;
  file: File[]; // array of Files in FormData
  numberOfImpressions: {
    biteReg: number;
    impressions: number;
  };
};

const useGetPreviousImp = (id: number | undefined): JSX.Element => {
  const [data, setData] = useState<Impression | null>(null);

  useEffect(() => {
    const getPreviousImpression = async () => {
      if (!id) return;
      const res = await api.get(`/orders/last/${id}`);
      setData(res.data.result);
    };
    getPreviousImpression();
  }, [id]);

  return createImpressionMessage(data);
};

export default useGetPreviousImp;

const createImpressionMessage = (
  impression: Impression | null
): JSX.Element => {
  if (!impression) return <>Awaiting Data</>; // for the sake of typescript

  const bold = (text: string | number) => <strong>{text}</strong>;
  const formattedDate = new Date(impression.date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  const messageMap: Record<Impression["type"], JSX.Element> = {
    Digital: (
      <>
        The last STL impression was sent on order ID: {bold(impression.orderId)}{" "}
        on {bold(formattedDate)}.
      </>
    ),
    Scanner: (
      <>
        The last impression was sent through the scanner portal on order ID:{" "}
        {bold(impression.orderId)} on {bold(formattedDate)}.
      </>
    ),
    Physical: (
      <Box sx={{ paddingBottom: "1em" }}>
        The last physical impression was sent on order ID:{" "}
        {bold(impression.orderId)} on {bold(formattedDate)}. Impressions:{" "}
        {bold(impression.numberOfImpressions?.impressions)}, Bite Register:{" "}
        {bold(impression.numberOfImpressions?.biteReg)}.
      </Box>
    ),
  };

  return (
    messageMap[impression.type] || (
      <>
        Existing impression not found. Please send a new impression. Thank you!
      </>
    )
  );
};
